import { sprintf } from 'sprintf-js';

import { Box } from 'components/Box/Box';
import { H2 } from 'components/Text/H2';
import { Text } from 'components/Text/Text';
import type { ApiOrg } from 'modules/listing/api/org/types/ApiOrg';
import { getCityStateString } from 'utils/address/getCityStateString';
import { monthAndYear } from 'utils/date';

type Props = {
  org: ApiOrg;
};

export function ViewOrgPageSidebarTitle({ org }: Props) {
  return (
    <Box display="flex" flexDirection="column">
      <H2 styleAs="h3" m="0">
        {org.name}
      </H2>
      <Box my="4px">
        {org.address && <>{getCityStateString(org.address)}</>}
      </Box>
      <Text
        display={['inline-block', 'inline-block', 'inline-block', 'block']}
        color="lightContentGrey"
      >
        {sprintf(getText('Joined in %(monthAndYear)s'), {
          monthAndYear: monthAndYear(org.created),
        })}
      </Text>
    </Box>
  );
}
